export default {
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARN: 'WARN',
  SUCCESS: '_SUCCESS',
};
